import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/ScrollReveal';

const CITIES = ['London', 'Manchester'];

export default function CoverageSection({ showLondonLink = false }) {
  return (
    <section className="py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center">
            <p className="caps-label text-orange mb-4">Coverage</p>
            <h2 className="font-display font-extrabold text-navy mb-8" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Serving London and Manchester
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 gap-6 mt-12 max-w-4xl mx-auto">
          {CITIES.map((city, i) => (
            <ScrollReveal key={city} delay={i * 0.1}>
              <div className="border-l-2 border-orange pl-6 py-4">
                <h3 className="text-3xl font-bold text-navy">{city}</h3>
                <p className="text-sm text-muted-foreground mt-1">Available 7 days a week</p>
                {showLondonLink && city === 'London' && (
                  <Link to="/property-inventory-london" className="inline-block mt-3 text-sm font-semibold text-navy underline hover:text-orange transition-colors">
                    Property inventories in London
                  </Link>
                )}
                {showLondonLink && city === 'Manchester' && (
                  <Link to="/property-inventory-manchester" className="inline-block mt-3 text-sm font-semibold text-navy underline hover:text-orange transition-colors">
                    Property inventories in Manchester
                  </Link>
                )}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}